import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 17px;
    height: 17px;
  }
`;

export const IconBiggerWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
`;
